import React from "react";
import { typography, textColors, surfaces, borders } from "../../design-system/tokens";
import {
  AFFILIATE_PORTAL_BLOCKED_MESSAGE,
  getAffiliatePortalBlockedMessage,
} from "../utils/affiliatePortalMessages";

/**
 * Full-page / inline notice when an affiliate account cannot use the portal.
 */
const AffiliatePortalBlockedNotice = ({ message = AFFILIATE_PORTAL_BLOCKED_MESSAGE }) => {
  const body = getAffiliatePortalBlockedMessage({ error: message }) || AFFILIATE_PORTAL_BLOCKED_MESSAGE;

  return (
    <div className="max-w-xl mx-auto px-4 py-12" role="alert" aria-live="polite">
      <div className={`rounded-2xl border ${borders.glass} ${surfaces.glassCard} p-6 sm:p-8 space-y-3`}>
        <h1 className={`${typography.h3} ${textColors.primary}`}>Affiliate Portal access unavailable</h1>
        <p className={`${typography.body} ${textColors.secondary} whitespace-pre-wrap`}>{body}</p>
        <p className={`${typography.bodySmall} ${textColors.muted}`}>
          You may still use your regular myvitae.ai account. Portal access can be restored only by
          MyVitae after review.
        </p>
      </div>
    </div>
  );
};

export default AffiliatePortalBlockedNotice;
